import React, { Component } from 'react';
import {Map} from 'google-maps-react';


class GoogleMap extends Component {
  render() {
    const { google, mapStyles, initCenter, initZoom, centerTo, markers } = this.props;

    return (
      <Map
        google={google} 
        initialCenter={initCenter}
        zoom={initZoom}
        center={centerTo}
        styles={mapStyles}
      >

      { markers }

      </Map>
    );
  }
}


export default GoogleMap;


// WEBPACK FOOTER //
// ./src/common/MapContainer/GoogleMap.js